import type { MarkdownModeView } from '@atlassian/editor-plugin-markdown-mode';

import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';

export type MarkdownViewMode = MarkdownModeView;

export const DEFAULT_MARKDOWN_VIEW_MODE: MarkdownViewMode = 'syntax';

const isMarkdownViewMode = (value: unknown): value is MarkdownViewMode =>
	value === 'syntax' || value === 'wysiwyg' || value === 'preview';

export const readStoredMarkdownViewMode = (): MarkdownViewMode => {
	const stored = confluenceLocalStorageInstance.getItem(keys.MARKDOWN_VIEW_MODE);
	if (isMarkdownViewMode(stored)) {
		return stored;
	}
	// No valid preference stored — persist the default so the toggle can read it.
	confluenceLocalStorageInstance.setItem(keys.MARKDOWN_VIEW_MODE, DEFAULT_MARKDOWN_VIEW_MODE);
	return DEFAULT_MARKDOWN_VIEW_MODE;
};

export const writeStoredMarkdownViewMode = (mode: MarkdownViewMode): void => {
	confluenceLocalStorageInstance.setItem(keys.MARKDOWN_VIEW_MODE, mode);
};
